// environment.temp.ts
import { environment as defaultEnvironment } from './environment.defaults';

export const environment = {
  ...defaultEnvironment,
  production: true,
  stage: 'temp',
  apiBaseUrl: 'https://api.heardis.com/v1/default',
  assetsBaseUrl: 'https://private.heardis.com',
  streamBaseUrl: 'https://stream.heardis.com',
  onDemandBaseUrl: 'https://play.heardis.com',
  streamWebHostingUrl: 'https://play.heardis.com',
  compilationBaseUrl: 'https://play.heardis.com',
  aws: {
    region: 'eu-west-1',
    cognitoRegion: 'eu-central-1',
    userPoolId: 'eu-central-1_21DlqBRX7',
    userPoolWebClientId: '53dc76g2cfe6lhlh1vpacd1idq',
    identityPoolId: 'eu-central-1:c32ebd9c-d7ad-40f7-9ae1-34d2c1f3ea68',
    schedulesBucketName: 'abcdj-schedules-production',
    audioBucketName: 'abcdj-audio-files-production',
    artworkBucketName: 'abcdj-artwork-files-production',
    plgLogGroupName: '/aws/lambda/plg-production-generate-playlist',
  },
};
